const fetchAuthenticatedContent = require("./fetchAuthenticatedContent");

module.exports = function saveUser(dispatch, user) {
	// console.warn("saveUser", dispatch);
	let method = "POST";
	let endpoint = `user/user`;
	if (user.id) {
		endpoint += `/${user.id}`;
		method = "PATCH";
	}

	return fetchAuthenticatedContent({
		dispatch,
		endpoint,
		method,
		body: {
			data: { ...user },
		},
	});
};
